import React, { useState } from "react";
import { Card } from "antd";
import ReactApexChart from "react-apexcharts";
import DrawerPlat from "../../../properties/Drawer/DrawerPlat";
import { useEffect } from "react";

const ProductionLinuxChart = (props) => {
  const [prodlist, setprodlist] = useState([]);
  const [nonprodlist, setnonprodlist] = useState([]);
  const record = props.prodlist;

  useEffect(() => {
    const patchRecords = record.filter((record) => record.compliants);
    setprodlist(patchRecords);
    const patchRecords2 = record.filter((record) => record.non_complaints);
    setnonprodlist(patchRecords2);
  }, [record]);

  const t1 = prodlist.length;
  const t2 = nonprodlist.length;
  var countfilteredLin1 = props.countsos.filter(function (element) {
    return (
      element.environment == "production" &&
      element.os == "linux" &&
      element.patch_status == "compliance"
    );
  }).length;
  var countfilteredLin2 = props.countsos.filter(function (element) {
    return (
      element.environment == "production" &&
      element.os == "linux" &&
      element.patch_status == "non-compliance"
    );
  }).length;
  const compliantsSum = record.reduce(
    (sum, item) => sum + parseInt(item.compliants),
    0
  );
  const nonComplaintsSum = record.reduce(
    (sum, item) => sum + parseInt(item.non_complaints),
    0
  );
  const series = [compliantsSum, nonComplaintsSum];
  // const series =[t1,t2]
  // const series = [countfilteredLin1, countfilteredLin2];
  const options = {
    chart: {
      type: "donut",
    },
    legend: {
      show: false,
    },
    colors: ["#84AEE7", "#FFEAA0"],
    dataLabels: {
      enabled: true,
      formatter: function (val) {
        return Math.round(val);
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
          legend: {
            position: "bottom",
          },
        },
      },
    ],
    title: {
      show: true,
      text: "Linux",
      style: {
        textAlign: "center",
        color:"#FFF",
      },
    },
    // plotOptions: {
    //   pie: {
    //     donut: {
    //       labels: {
    //         show: true,
    //         name: {
    //           show: true,
    //         },
    //         value: {
    //           show: true,
    //         },
    //         total: {
    //           show: true,
    //           showAlways: true,
    //           label: "Security Score",
    //           formatter: function (val) {
    //             return 87 + "%";
    //           },
    //         },
    //       },
    //     },
    //   },
    // },
  };

  return (
    <>
      {/* <Card>
        <> */}
      <div id="chart">
        <ReactApexChart options={options} series={series} type="donut" />
      </div>
      {/* </>
      </Card> */}
    </>
  );
};

export default ProductionLinuxChart;
